import SignUpHeader from './SignUpHeader';
import SignupForm from './SignupComponent';
import { VectorIcon } from './VectorIcon.tsx';
import { VectorIcon1 } from './VectorIcon1.tsx';
import { useLocation } from 'react-router-dom';

function SignupPage() {
  const location = useLocation();
  const defaultTab = location.state?.defaultTab || null;

  return (
    <div className="w-full min-h-screen bg-gray-50">
      <div className="fixed top-0 left-0 w-full h-20 bg-white border-b border-gray-200 shadow-sm z-50">
        <SignUpHeader />
      </div>
      <div className="pt-20 relative z-10">
        <div className="w-full">
          <SignupForm defaultTab={defaultTab} />
        </div>
      </div>
      <div className="fixed -left-24 top-1/4 w-72 h-80 overflow-hidden hidden lg:block opacity-20 z-0">
        <VectorIcon1 className="w-full h-full" />
      </div>
      <div className="fixed -right-24 bottom-0 w-96 h-80 overflow-hidden hidden lg:block opacity-20 z-0">
        <VectorIcon className="w-full h-full" />
      </div>
    </div>
  );
}

export default SignupPage;